import React, { useState } from 'react';
import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  Popover,
  Stack,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { TP_COLORS } from '../../constants';
import { useAppSelector } from '../../hooks';
import { getAuthState } from '../../store/AuthSlice';

const iconButtonStyles: IconButtonProps['style'] = {
  backgroundColor: TP_COLORS.black,
  borderRadius: '7px',
};

const menuButtonProps: ButtonProps = {
  size: 'small',
  color: 'inherit',
  variant: 'text',
  sx: {
    justifyContent: 'flex-start',
  },
};

export interface IMenuButton {
  toggleTheme: () => void;
  handleReportModalOpen: () => void;
  handleQuestionsModalOpen: () => void;
  handleWhiteboardEnable: () => void;
}

const MenuButton: React.FC<IMenuButton> = ({
  toggleTheme,
  handleReportModalOpen,
  handleQuestionsModalOpen,
  handleWhiteboardEnable,
}) => {
  const theme = useTheme();
  const belowSm = useMediaQuery(theme.breakpoints.down('sm'));

  // Store
  const authState = useAppSelector(getAuthState);

  const userRole = authState.user?.role.name;

  // State
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'menu-popover' : undefined;

  return (
    <>
      <Tooltip title="Menu">
        <IconButton
          aria-describedby={id}
          onClick={handleClick}
          style={iconButtonStyles}
        >
          <MenuIcon style={{ color: TP_COLORS.white }} />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{ marginTop: '5px' }}
      >
        <Stack style={{ margin: '10px' }}>
          {userRole === 'Tutor' ? (
            <>
              <Button
                {...menuButtonProps}
                onClick={() => {
                  handleQuestionsModalOpen();
                  handleClose();
                }}
              >
                + Add Questions
              </Button>
              {belowSm && (
                <Button
                  {...menuButtonProps}
                  onClick={() => {
                    handleWhiteboardEnable();
                    handleClose();
                  }}
                >
                  Whiteboard
                </Button>
              )}
            </>
          ) : null}
          {belowSm ? (
            <>
              <Button
                {...menuButtonProps}
                onClick={() => {
                  toggleTheme();
                  handleClose();
                }}
              >
                Change Theme
              </Button>
              <Button
                {...menuButtonProps}
                onClick={() => {
                  handleReportModalOpen();
                  handleClose();
                }}
              >
                Report Resource
              </Button>
            </>
          ) : null}
        </Stack>
      </Popover>
    </>
  );
};

export default MenuButton;
